// extracted by mini-css-extract-plugin
module.exports = {"FixTextAlignment":"Radio_FixTextAlignment__2OYjn","AriaDescriptionSpecial":"Radio_AriaDescriptionSpecial__1IgxL","Radio":"Radio_Radio__2-T4F"};